export default "__VITE_ASSET__CE88pBXm__"